import styled from 'styled-components';

import { respondDown } from 'styles/mixins';
import { Breakpoints, COLORS } from 'styles/style-constants';

export const ChartPlot = styled.div`
    width: 100%;
    height: 32rem;
    padding: 1.6rem;
    display: flex;
    flex-direction: column;
    gap: 1.6rem;
    color: ${COLORS.textGray};
    font-size: 1.4rem;
`;

export const ChartGrid = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-bottom: 0.1rem solid ${COLORS.gray100};

    > div {
        border-top: 0.1rem solid ${COLORS.gray100};
    }
`;

export const ChartHeading = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1.6rem;
`;

export const TableHeader = styled.div`
    display: grid;
    grid-template-columns: 6.5fr 2fr 2fr 3fr 3fr;
    align-items: center;
    min-height: 5.2rem;
    padding: 0.8rem;
    gap: 1.6rem;
    font-size: 1.4rem;
    color: ${COLORS.textGray};

    > :nth-child(2),
    > :nth-child(3) {
        text-align: right;
    }

    ${respondDown(Breakpoints.lg)`display: none;`}
`;

export const PoolRow = styled.div`
    display: grid;
    grid-template-columns: 6.5fr 2fr 2fr 3fr 3fr;
    align-items: center;
    min-height: 11.4rem;
    padding: 0.8rem;
    gap: 1.6rem;
    border-bottom: 0.1rem solid ${COLORS.gray100};

    ${respondDown(Breakpoints.lg)`
        grid-template-columns: 1fr;
        padding: 2.7rem 1.6rem 1.6rem;
        background: ${COLORS.surface};
        margin-bottom: 1.6rem;
        gap: 1.6rem;
    `}
`;

export const PoolIdentity = styled.div`
    display: flex;
    gap: 1.6rem;
    align-items: center;

    ${respondDown(Breakpoints.lg)`
        flex-direction: column;
        align-items: flex-start;
        min-height: 13.2rem;
    `}
`;

export const PoolValue = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    min-height: 2.8rem;
    > span {
        display: none;
    }
    &:nth-child(n + 4) {
        justify-content: flex-start;
    }

    ${respondDown(Breakpoints.lg)`
        &, &:nth-child(n + 4) { justify-content: space-between; }
        > span { display: inline; color: ${COLORS.textGray}; }
    `}
`;
